import React from 'react';

// import default view
import { lineChart as LineChartView } from './lineChart.view';

/**
 * @type {function}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @param {object} Component - A React component
 * @example
 * import { LineChart } from 'modules/lineChart';
 *
 * // render
 * <LineChart propName='propValue'/>
 */
export class LineChart extends React.Component {
    constructor( props ) {
        super( props );
    }

    render() {
        return (
            <LineChartView { ...this.props } />
        );
    }
}

// set display name
LineChart.displayName = 'LineChart';

// default props
LineChart.defaultProps = {
    width: 800,
    height: 300,
    margin: { top: 50, right: 30, left: -25, bottom: 5},
    YaxisLine: false,
    XaxisLine: false,
    XtickLine: false,
    YtickLine: false,
    active: false,
    interval: 0,
    minTickGap: 10,
    yAxislabel: ''
};

// prop types
LineChart.propTypes = {};
